<template>
  <div class="main">
    <div class="list">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="item in list"
          :ref="setItemRef"
          :key="item"
          :title="item"
        />
      </van-list>
      <div class="input-box">
        <van-field @focus="focus" v-model="value" @keydown.enter="enter" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUpdate, nextTick } from "vue";
import { useWindowSize } from "@vant/use";
export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);

    const onLoad = () => {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 4; i++) {
          list.value.push(list.value.length + 1);
        }

        // 加载状态结束
        loading.value = false;

        // 数据全部加载完成
        if (list.value.length >= 4) {
          finished.value = true;
        }
      }, 1000);
    };
    const value = ref("");
    const enter = async () => {
      list.value.push(value.value);
      await nextTick();
      scrollIntoView(itemRefs.pop().$el);
      value.value =
        window.innerHeight + "," + itemRefs.pop().$el.getBoundingClientRect().y;
    };
    let itemRefs = [];
    const setItemRef = (el) => {
      if (el) {
        itemRefs.push(el);
      }
    };
    onBeforeUpdate(() => {
      itemRefs = [];
    });

    //点击输入顶上去
    const scrollIntoView = () => {
      setTimeout(() => {
        // target.scrollIntoView();
      }, 500);
    };

    const focus = () => {
      setTimeout(() => {
        // document.body.scrollTop = document.body.scrollHeight;
        document.body.style.height = "200px";
        value.value =
          window.innerHeight +
          "," +
          itemRefs.pop().$el.getBoundingClientRect().y;
      }, 500);
    };

    const { height } = useWindowSize();
    value.value = height.value;

    return {
      list,
      onLoad,
      loading,
      finished,
      value,
      enter,
      focus,
      setItemRef,
    };
  },
};
</script>

<style lang="less">
.main {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
}
.list {
  position: absolute;
  left: 0;
  right: 0;
  height: 100vh;
  overflow: auto;
}
.input-box {
  position: absolute;
  background: red;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
